export default __webpack_public_path__ + "static/media/gnl6.35d575bf.jpg";